export default "__VITE_ASSET__Ctavzp8W__"